import * as React from 'react';
export var ViewHeadRendererContext = React.createContext(null);
//# sourceMappingURL=ViewHeadRendererContext.js.map